import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CalendarFeedLinks, SettingsService } from '../settings.service';

@Component({
  selector: 'edu-calendar-integration',
  templateUrl: './calendar-integration.component.html',
  styleUrl: './calendar-integration.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CalendarIntegrationComponent implements OnInit {
  loading = true;
  working = false;
  enabled = false;
  webcalUrl = '';
  httpsUrl = '';

  constructor(
    private settingsService: SettingsService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.settingsService.getCalendarFeedStatus().subscribe({
      next: (status) => this.applyStatus(status),
      error: () => {
        this.loading = false;
      },
    });
  }

  enable(): void {
    this.working = true;
    this.settingsService.enableCalendarFeed().subscribe({
      next: (status) => {
        this.applyStatus(status);
        this.working = false;
      },
      error: () => {
        this.working = false;
        this.notify('Could not turn on calendar sync. Please try again.');
      },
    });
  }

  disable(): void {
    this.working = true;
    this.settingsService.disableCalendarFeed().subscribe({
      next: () => {
        this.enabled = false;
        this.webcalUrl = '';
        this.httpsUrl = '';
        this.working = false;
      },
      error: () => {
        this.working = false;
        this.notify('Could not turn off calendar sync. Please try again.');
      },
    });
  }

  copyUrl(): void {
    if (!this.httpsUrl || !navigator.clipboard) {
      return;
    }
    navigator.clipboard.writeText(this.httpsUrl).then(
      () => this.notify('Subscription link copied'),
      () => this.notify('Could not copy the link'),
    );
  }

  private applyStatus(status: CalendarFeedLinks): void {
    this.enabled = status.enabled;
    this.webcalUrl = status.webcalUrl;
    this.httpsUrl = status.httpsUrl;
    this.loading = false;
  }

  private notify(message: string): void {
    this.snackBar.open(message, 'Dismiss', { duration: 3000 });
  }
}
